<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li><a [routerLink]="['/']">Home</a></li>
      <li>Artikelvorlagen</li>
    </ul>
  </div>
  <a [routerLink]="['/', 'artikelvorlagen', 'neu']" class="bm-btn"> <i class="fa fa-plus"></i> Neue Artikelvorlagen </a>
  <input class="bm-input" type="text" (input)="quicksearchChanged($event)" placeholder="Schnellfilter" />
</div>

<div class="page-content page-frame">
  <ag-grid-angular
    class="ag-theme-quartz h-full"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [rowData]="articleTemplates"
    [rowSelection]="rowSelection"
    [initialState]="initialState"
    [paginationPageSize]="paginationPageSize"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    (gridReady)="onGridReady($event)"
  />
</div>
